import React from 'react'
import qs from 'qs'

import PeerConversation from '../../../molecules/PeerConversation'
import ClientConversation from '../../../molecules/ClientConversation'

import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useLocation } from 'react-router'

const ListItem = ({
  id,
  contacts,
  all,
  isDirect,
  handleCloseConversation,
  current,
  order,
  selectHandler,
  sort,
  allAgents,
  i
}) => {
  const convo = React.useMemo(() => {
    const convoObj = all.find(obj => obj.session === id)

    if (convoObj) {
      return { ...convoObj, found: true }
    }

    return {
      session: '',
      latest_activity: '',
      closed_at: '',
      ended_at: '',
      owner_id: '',
      found: false
    }
  }, [all, id])

  const {
    session,
    latest_activity: latestActivity,
    ended_at,
    owner_id,
    found
  } = convo

  const handleClick = React.useCallback(() => {
    selectHandler(session)
  }, [selectHandler, session])

  const commonProps = React.useMemo(
    () => ({
      onClick: handleClick,
      sorting: sort,
      latestActivity
    }),
    [handleClick, sort, latestActivity]
  )

  // Hide duplicates
  const prevOwnerIDX = React.useMemo(
    () =>
      order.findIndex(cID => {
        const convo = all.find(obj => obj.session === cID)
        return convo?.owner_id === owner_id
      }),
    [order, all, owner_id]
  )

  const related = React.useMemo(
    () => all.filter(obj => obj.owner_id === owner_id),
    [all, owner_id]
  )
  const selected = React.useMemo(
    () => related.some(obj => obj.session === current),
    [related, current]
  )

  if (!found) {
    return null
  }

  if (id === contacts) {
    return null
  }

  if (!isDirect && !ended_at) {
    return null
  }

  // Peer chat case
  if (isDirect) {
    return (
      <PeerConversation
        key={id}
        {...commonProps}
        handleCloseConversation={handleCloseConversation}
        conversation={convo}
        selected={current === session}
        allAgents={allAgents}
      />
    )
  }

  if (prevOwnerIDX < i) {
    return null
  }

  return (
    <ClientConversation
      key={id}
      {...commonProps}
      ownerID={owner_id}
      related={related}
      selected={selected}
    />
  )
}

const ConversationList = ({
  all,
  isDirect,
  handleCloseConversation,
  current,
  selectHandler,
  sort,
  allAgents
}) => {
  const location = useLocation()

  const { order } = useQueueState()
  const { contacts } = React.useMemo(
    () => qs.parse(location.search, { ignoreQueryPrefix: true }),
    [location.search]
  )

  return (
    <>
      {order.map((id, i) => (
        <ListItem
          key={`${id}-${i}`}
          id={id}
          contacts={contacts}
          all={all}
          isDirect={isDirect}
          handleCloseConversation={handleCloseConversation}
          current={current}
          order={order}
          selectHandler={selectHandler}
          sort={sort}
          allAgents={allAgents}
          i={i}
        />
      ))}
    </>
  )
}

export default ConversationList
